<div class="subscription-container">
    <div class="header">
        <h1>Subscription Plans</h1>
        <p>Choose the right plan to grow your wedding business</p>
    </div>

    <div class="plans-wrapper">
        <div class="plan-card" *ngFor="let plan of merchantPlans" 
             [class.premium]="plan.hasPremiumBadge" 
             [class.active-plan]="currentTier === plan.planCode">
             
            <div class="current-badge" *ngIf="currentTier === plan.planCode">Current Plan</div>
            <div class="popular-badge" *ngIf="plan.isPopular && currentTier !== plan.planCode">Most Popular</div>
            
            <div class="plan-header">
                <h2>{{ plan.displayName }}</h2>
                <div class="price">₹{{ plan.price }}<span>/{{ plan.billingCycle }}</span></div>
                <p class="target-audience">{{ plan.targetAudience }}</p>
            </div>
            
            <ul class="features">
                <li>
                    <span class="material-symbols-outlined check">check_circle</span> 
                    <b *ngIf="plan.maxServices === 999">Unlimited</b><span *ngIf="plan.maxServices !== 999">Up to {{ plan.maxServices }}</span> Services
                </li>
                <li>
                    <span class="material-symbols-outlined check">check_circle</span> 
                    <b *ngIf="plan.maxImagesPerService === 999">Unlimited</b><span *ngIf="plan.maxImagesPerService !== 999">{{ plan.maxImagesPerService }}</span> Portfolio images per service
                </li>
                <li>
                    <span class="material-symbols-outlined check">check_circle</span> Unlimited Direct Enquiries
                </li>
                <li>
                    <span class="material-symbols-outlined check">check_circle</span> 
                    <span *ngIf="plan.searchPriority > 0">Priority in Search Results</span>
                    <span *ngIf="plan.searchPriority <= 0">Standard search ranking</span>
                </li>
                <li>
                    <span class="material-symbols-outlined" [class.check]="plan.allowsVideoReels" [class.cancel]="!plan.allowsVideoReels">
                        {{ plan.allowsVideoReels ? 'check_circle' : 'cancel' }}
                    </span> 
                    {{ plan.allowsVideoReels ? 'Video Reels upload' : 'No Video Reels upload' }}
                </li>
                <li>
                    <span class="material-symbols-outlined" [class.check]="plan.hasPremiumBadge" [class.cancel]="!plan.hasPremiumBadge">
                        {{ plan.hasPremiumBadge ? 'check_circle' : 'cancel' }}
                    </span> 
                    {{ plan.hasPremiumBadge ? '"Premium" & "Verified" Badges' : 'No Premium/Verified Badges' }}
                </li>
                <li>
                    <span class="material-symbols-outlined" [class.check]="plan.allowsAds" [class.cancel]="!plan.allowsAds">
                        {{ plan.allowsAds ? 'check_circle' : 'cancel' }}
                    </span> 
                    {{ plan.allowsAds ? 'Premium Sponsored Advertisements' : 'No Sponsored Advertisements' }}
                </li>
                <li *ngIf="plan.directPhoneLeads">
                    <span class="material-symbols-outlined check">check_circle</span> Direct Phone Leads
                </li>
                <li *ngIf="plan.dedicatedAccountManager">
                    <span class="material-symbols-outlined check">check_circle</span> Dedicated Account Manager
                </li>
            </ul>
            
            <div class="action-btn-wrapper">
                <button class="btn btn-disabled" *ngIf="currentTier === plan.planCode" disabled>Currently Active</button>
                <button class="btn btn-premium" *ngIf="currentTier !== plan.planCode && plan.planCode === 'PREMIUM'" [disabled]="loading" (click)="upgradeToPremium()">
                    {{ loading ? 'Upgrading...' : 'Upgrade to Premium' }}
                </button>
            </div>
        </div>
    </div>

</div>
